<script>
	import { User } from '../store.js';

	export let user;
	
	$: isLoggedIn = !!user && user !== 'null';
</script>

<nav>
	<a href='https://www.airbetter.com' class='logo'>
		<img src='/img/airbetterLogo.svg' alt='airbetter imagotype' width='60px' class='imago' />
		<img src='/img/airbetterText.svg' alt='airbetter logo text' width='167px' class='typography' />
	</a>
	{#if isLoggedIn}
	<button on:click={() => User.logout()}>Logout</button>
	{/if}
</nav>

<style>
	nav{
		display: flex;
		background-color: #EF4064;
		padding:10px 50px;
		max-height: 50px
	}
	nav .logo{
		display: flex;
		flex-grow:1;
	}
	nav button{
		background-color: transparent;
		border:none;
		color:white;
	}
	@media (max-width:560px) {
		nav{
			padding:5px 25px;
		}
		nav .logo img.imago{
			width: 30px;
		}
		nav .logo img.typography{
			width: 83px;
		}
		nav button{
			font-size:12px;
		}
	}
</style>